import { createBrowserRouter, Navigate } from 'react-router-dom';
import Login from '../pages/login.js';
import ForgotPassword from '../pages/ForgotPassword.js';
import { Layout } from '../components/layout/Layout';
import Dashboard from '../pages/Dashboard';
import { UserManagement } from '../pages/UserManagement.js';
import { Role } from '../pages/Role.js';
import { Permission } from '../pages/Permission.js';
import Loginn from '../pages/Authentication/Login1.js';
import BulkImport from '../pages/bulkImport.js';
import SchedulerDialogComponent from '../pages/schedule-timing.js';
import EmailNotification from '../pages/emailNotification.js';

import SchedulerComponent from '../pages/Scheduler.js';
import Notifications from '../pages/Notifications.js';
import AuthGuard from '../components/guards/AuthGuard'; // Import the AuthGuard
import Firmware from '../pages/firmware.js';

// import NotifyComponent from '../pages/notify.js';
import Profile from '../pages/profile.js';
import ReleaseNotes from '../pages/ReleaseNotes.js';
import Reports from '../pages/Reports.js';
import LandingPage from '../landing/LandingPage.js';
import UsersPage from '../pages/users.js';
import RolesPage from '../pages/roles.js';
import GroupsPage from '../pages/groups.js';
import PermissionsPage from '../pages/permissions.js';
import PoliciesPage from '../pages/policies.js';
import UrlsPage from '../pages/whitelisturls.js';
import ProtocolRulesPage from '../pages/ProtocolRulesPage.js';
import ActiveSessions from '../pages/ActiveSessions.js';
import LatestBrowserUpdates from '../pages/LatestBrowserUpdates.js';
import Devices from '../pages/Devices.js';
import Questionnaire from '../pages/Questionnaire.js';
import MFADevice from '../pages/MFADevice.js';
import WindowsAgentDevices from '../pages/WindowsAgentDevices.js';
// Retired: AD sync now runs through the gateway page
// import AdIntegration from '../pages/adintegration.js';
import ApplicationsPage from '../pages/applications.js';
import NotFound from '../pages/NotFound.js';
import ScimIntegrationsPage from '../pages/ScimIntegrations';
import GatewayMonitoringPage from '../pages/GatewayMonitoring';

import PermissionGuard from '../components/guards/PermissionGuard';
import AccessDenied from '../components/guards/AccessDenied';
import { FEATURES } from '../utils/rbac';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Login />
  },
  // {
  //   path: '/',
  //   element: <LandingPage />
  // },
  {
    path: '/forgot-password',
    element: <ForgotPassword />
  },
  {
    // Protected routes are wrapped with AuthGuard
    element: <AuthGuard />,
    children: [
      {
        path: '/',
        element: <Layout />, // Layout that wraps all inner pages
        children: [
          {
            path: 'home',
            element: (
              <PermissionGuard feature={FEATURES.DASHBOARD}>
                <Dashboard />
              </PermissionGuard>
            )
          },
          {
            path: 'dashboard',
            element: (
              <PermissionGuard feature={FEATURES.DASHBOARD}>
                <Dashboard />
              </PermissionGuard>
            )
          },
          {
            path: 'asset',
            element: <Firmware />
          },
          {
            path: 'user-management',
            element: (
              <PermissionGuard feature={FEATURES.USER_MANAGEMENT}>
                <UserManagement />
              </PermissionGuard>
            )
          },
          {
            path: 'role',
            element: (
              <PermissionGuard feature={FEATURES.ROLE_MASTER}>
                <Role />
              </PermissionGuard>
            )
          },
          {
            path: 'permission',
            element: <Navigate to="/role" replace />
          },
          {
            path: 'loginn',
            element: <Loginn />
          },
          {
            path: 'bulk-import',
            element: <BulkImport />
          },
          {
            path: 'scheduler',
            element: <SchedulerDialogComponent />
          },
          {
            path: 'email-scheduler',
            element: <EmailNotification />
          },
        
          {
            path: 'scheduler1',
            element: <SchedulerComponent />
          },
          {
            path: 'notifications',
            element: <Notifications />
          },
          {
            path: 'TestComponent',
            element: <ForgotPassword />
          },
          {
            path: 'profile',
            element: <Profile />
          },
        
          {
            path: 'policies',
            element: <PoliciesPage />
          },
          {
            path: 'users',
            element: <UsersPage />
          },
          {
            path: 'roles',
            element: <RolesPage />
          },
          {
            path: 'groups',
            element: <GroupsPage />
          },
          {
            path: 'permissions',
            element: <PermissionsPage />
          },
        
          {
            path: 'devices',
            element: (
              <PermissionGuard feature={FEATURES.DEVICES}>
                <MFADevice />
              </PermissionGuard>
            )
          },
          {
            path: 'windows-agent-devices',
            element: (
              <PermissionGuard feature={FEATURES.WINDOWS_AGENT_DEVICES}>
                <WindowsAgentDevices />
              </PermissionGuard>
            )
          },
          // Retired: AD sync now runs through the gateway page
          // {
          //   path: 'admin/ad-integration',
          //   element: (
          //     <PermissionGuard feature={FEATURES.AD_INTEGRATION}>
          //       <AdIntegration />
          //     </PermissionGuard>
          //   )
          // },
          // {
          //   path: 'ad-integration',
          //   element: (
          //     <PermissionGuard feature={FEATURES.AD_INTEGRATION}>
          //       <AdIntegration />
          //     </PermissionGuard>
          //   )
          // },
          {
            path: 'applications',
            element: (
              <PermissionGuard feature={FEATURES.APPLICATIONS}>
                <ApplicationsPage />
              </PermissionGuard>
            )
          },
          {
            path: 'admin/scim',
            element: (
              <PermissionGuard feature={FEATURES.CONNECTIONS}>
                <ScimIntegrationsPage />
              </PermissionGuard>
            )
          },
          {
            path: 'admin/gateways',
            element: (
              <PermissionGuard feature={FEATURES.GATEWAYS}>
                <GatewayMonitoringPage />
              </PermissionGuard>
            )
          },
          {
            path: 'no-access',
            element: <AccessDenied featureName="any active modules" title="No Accessible Modules" />
          },
          {
            path: 'access-denied',
            element: <AccessDenied />
          }
        ]
      }
    ]
  },
  {
    path: '/404',
    element: <NotFound />
  },
  {
    path: '*',
    element: <NotFound />
  }
]);

export default router;
